export default __webpack_public_path__ + "static/header-marketing-3cf546e7d279316321a1d4703a465aee.png";